import {Flex, Text, Input} from '@priority-software/priority-style-react';
import React from 'react';

const AxisInput = ({
    title = '',
    value = '',
    compClass = '',
    onChange,
    helpText,
    placeholder,
    maxLength = 2,
    allowNegative = true,
    isError = false
}) => {
    const handleChange = event => {
        const isNumberRegEx = allowNegative ? new RegExp(/^-?\d+$/) : new RegExp(/^\d+$/);
        const value = event?.target?.value;
        const isMinusSign = allowNegative && value.length === 1 && value === '-';
        if (isNumberRegEx.test(value) || !value || isMinusSign) {
            onChange(event);
        }
    };

    const inputState = isError ? 'error' : null;

    return (
        <Flex
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            componentClasses={compClass}
        >
            <Text skin="label-1">{title}</Text>
            <Input
                value={value}
                onChange={e => handleChange(e)}
                placeholder={placeholder}
                size="large"
                type="text"
                maxLength={maxLength}
                state={inputState}
            />
        </Flex>
    );
};

export default AxisInput;
